const PROJECTS = [
    {
        "id": "23",
        "categories": ["mobile", "iot", "rnd"],
        "type": "Mobile - IoT - R&D",
        "title": "Blaze",
        "description": "Track aim. Stay safe. Hunt smarter. A mobile app for hunters that connects to a Bluetooth safety device for real-time aim tracking and situational awareness. Built with React Native and Expo, it pairs with an XSens DOT sensor via Bluetooth for real-time orientation and shot detection, uses Firebase for auth and real-time presence, and Google Maps for live location and heading.",
        "client": "Blaze",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/united-states-of-america-flag-png-large.png",
        "country": "United States",
        "date": "2026",
        "technologies": [
            "React Native",
            "Expo",
            "TypeScript",
            "Firebase",
            "Google Maps",
            "Bluetooth (BLE)",
            "XSens DOT",
            "expo-location",
            "expo-sensors"
        ],
        "url": null,
        "images": [
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-2.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-1.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-3.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-4.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-5.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-6.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-7.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-8.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-9.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-10.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-11.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-12.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-13.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-14.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-15.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-16.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-17.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/blaze-18.jpeg"
        ],
        "xs": 6
    },
    {
        "id": "22",
        "categories": ["mobile", "erp", "software"],
        "type": "Mobile App Development - ERP",
        "title": "Sunbeam e-Rep Mobile Application",
        "description": "A mobile enterprise application developed for Sunbeam Products & Distributors to manage field sales operations in real time. The app enables sales reps to manage customer visits, create orders, handle returns, record payments, and sync data with the Sunbeam ERP. It includes live location tracking during working hours, offline data capture with auto-sync, and invoice printing with EPSON dot matrix printers.",
        "client": "Sunbeam Products & Distributors",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/sri-lanka-flag-png-large.png",
        "country": "Sri Lanka",
        "date": "2025",
        "technologies": [
            "React Native",
            "Node.js",
            "REST APIs",
            "SQL",
            "Azure Services",
            "Google Maps API",
            "Background Location Services",
            "EPSON dot matrix printer",
            "Firebase"
        ],
        "url": "https://sunbeam.lk/",
        "images": [
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-1.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-2.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-3.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-4.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-5.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-6.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-7.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-8.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-9.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-10.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-11.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-12.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-13.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-14.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-15.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sunbeamapp-16.jpeg"
        ],
        "xs": 6
    },
    {
        "id": "19",
        "categories": ["web", "software", "erp"],
        "type": "Web - ERP Development",
        "title": "Sunbeam ERP System",
        "description": "A custom ERP system for Sunbeam Products & Distributors to manage inventory, sales, products, customers, suppliers, sales representatives and their performance. Includes production and product formulation management, raw material and wastage tracking, HR, sales performance reporting, EPSON invoice printing, and sales representative live location tracking.",
        "client": "Sunbeam Products & Distributors",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/sri-lanka-flag-png-large.png",
        "country": "Sri Lanka",
        "date": "2025",
        "technologies": [
            "React.js",
            "Node.js",
            "Azure Services",
            "SQL",
            "Google Cloud",
            "ERP System",
            "Custom Software"
        ],
        "url": "https://sunbeam.lk/",
        "images": [
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb1.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb2.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb3.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb4.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb5.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb6.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb7.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb8.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb9.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb10.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb11.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb12.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb13.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb14.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb15.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb16.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sb17.png"
        ],
        "xs": 6
    },
    {
        "id": "21",
        "categories": ["web", "software", "erp"],
        "type": "Web - ERP Development",
        "title": "Southland Supply Group",
        "description": "A web-based order queue management system integrated with Microsoft Dynamics NAV for Southland Supply Group. The Value Added Order Management Portal provides real-time embroidery job queues, role-based dashboards, bulk updates, workflow tracking, commenting, and granular access control, with a separate MySQL database for metadata such as comments, hold times, and workflow history.",
        "client": "Southland Supply Group",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/flag-jpg-xl-9-2048x1024.jpg",
        "country": "Australia",
        "date": "2025",
        "technologies": [
            "React.js",
            "Node.js",
            "MySQL",
            "Microsoft Dynamics NAV",
            "OData/SOAP",
            "REST APIs"
        ],
        "url": null,
        "images": [
            "https://ozcodelabsblob.blob.core.windows.net/projects/southland1.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/southland3.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/southland4.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/southland5.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/southland6.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/southland7.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/southland8.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/southland9.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/southland10.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/southland11.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/southland12.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/southland13.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/southland14.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/southland15.png",
            "https://ozcodelabsblob.blob.core.windows.net/projects/southland16.png"
        ],
        "xs": 6
    },
    {
        "id": "20",
        "categories": ["web", "design"],
        "type": "Web Development",
        "title": "LPN Productions Website",
        "description": "A modern, responsive website for LPN Productions, a leading creative production company in Sri Lanka specializing in video production, event coverage, and multimedia services. Built with React.js and Vite, it includes Home, About, Services, Portfolio, Clients, Contact, and Equipment Rental pages, with EmailJS contact forms, layered image animations, parallax scrolling, YouTube portfolio galleries, and an equipment rental system with dropdown selection and quantity management.",
        "client": "LPN Productions",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/sri-lanka-flag-png-large.png",
        "country": "Sri Lanka",
        "date": "2025",
        "technologies": [
            "React.js",
            "Vite",
            "React Router",
            "EmailJS",
            "Lucide React",
            "Framer Motion",
            "CSS-in-JS",
            "Responsive Design"
        ],
        "url": "https://lpn.lk/",
        "images": [
            "https://ozcodelabsblob.blob.core.windows.net/projects/lpn1.webp",
            "https://ozcodelabsblob.blob.core.windows.net/projects/lpn2.webp",
            "https://ozcodelabsblob.blob.core.windows.net/projects/lpn3.webp",
            "https://ozcodelabsblob.blob.core.windows.net/projects/lpn4.webp",
            "https://ozcodelabsblob.blob.core.windows.net/projects/lpn5.webp",
            "https://ozcodelabsblob.blob.core.windows.net/projects/lpn6.webp",
        ],
        "xs": 6
    },
    {
        "id": "18",
        "categories": ["web", "design"],
        "type": "Web Development",
        "title": "Visit Pearl",
        "description": "A full-featured tour booking platform for travelers all around the world. Find destinations, book tours and activities, accommodations and flights, with customized travel itineraries and real-time customer support. Built with React.js and Node.js on Azure Services with SQL storage and Google Cloud for analytics.",
        "client": "VisitPearl.com",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/flag-jpg-xl-9-2048x1024.jpg",
        "country": "Australia",
        "date": "2024",
        "technologies": [
            "React.js",
            "Node.js",
            "Azure Services",
            "SQL",
            "Google Cloud"
        ],
        "url": "https://www.visitpearl.com.au/",
        "images": [
            "https://ozcodelabsblob.blob.core.windows.net/projects/vp1.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/vp2.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/vp3.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/vp4.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/vp5.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/vp6.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/vp7.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/vp8.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/vp9.jpeg"
        ],
        "xs": 6
    },
    {
        "id": "17",
        "categories": ["web"],
        "type": "Web Development",
        "title": "CodeClubs Sri Lanka",
        "description": "CodeClubs Sri Lanka is a platform that connects students with coding clubs and bootcamps. Students can search for clubs, join and participate in events, while organizations manage memberships with real-time notifications and secure user management.",
        "client": "STEMUp Education Foundation",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/sri-lanka-flag-png-large.png",
        "country": "Sri Lanka",
        "date": "2025",
        "technologies": [
            "React.js",
            "Firebase",
            "Google Cloud"
        ],
        "url": "https://codeclubs.lk/",
        "images": [
            "https://ozcodelabsblob.blob.core.windows.net/projects/cc1.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/cc2.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/cc3.jpeg"
        ],
        "xs": 8
    },
    {
        "id": "16",
        "categories": ["mobile"],
        "type": "iOS App Development",
        "title": "Apple Weather App Clone",
        "description": "WeatherPro is a modern iOS weather application designed to provide real-time weather updates with a clean and intuitive UI. The app follows the MVVM architecture to ensure scalability and maintainability. It integrates with the OpenWeather API to fetch current weather conditions, hourly and daily forecasts, and detailed weather insights.",
        "client": "Personal Project",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/sri-lanka-flag-png-large.png",
        "country": "Sri Lanka",
        "date": "2025",
        "technologies": [
            "Swift",
            "UIKit",
            "MVVM",
            "Core Data",
            "OpenWeather API",
            "Firebase"
        ],
        "url": null,
        "images": [
            "https://i.ibb.co/0VJMrtrP/weather-4.png",
            "https://i.ibb.co/vb3MyCM/weather-3.png",
            "https://i.ibb.co/qY2PbQX7/weather-2.png",
            "https://i.ibb.co/jZPXGC66/weather-1.png"
        ],
        "xs": 4
    },
    {
        "id": "15",
        "categories": ["software", "web", "wordpress"],
        "type": "Fullstack Development",
        "title": "Labor Friends of Israel (Custom Form Plugin) - Australia",
        "description": "A WordPress custom form plugin for Labor Friends of Israel to create and manage forms on their website, with CRM integration for lead management. Built with WordPress, PHP, and JavaScript to support customized fields, layouts, submissions tracking, and secure form handling.",
        "client": "Orion Soft",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/flag-jpg-xl-9-2048x1024.jpg",
        "country": "Australia",
        "date": "2024",
        "technologies": [
            "WordPress",
            "PHP",
            "JavaScript"
        ],
        "url": "https://www.laborfriendsofisrael.au/",
        "images": [
            "https://ozcodelabsblob.blob.core.windows.net/projects/lfi1.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/lfi2.jpeg"
        ],
        "xs": 4
    },
    {
        "id": "14",
        "categories": ["web", "design"],
        "type": "Web Development",
        "title": "Silicon Surge",
        "description": "A modern and responsive website for Silicon Surge, a cloud consulting company that provides services to startups and enterprises. Built with React.js and Email.js for lead generation via a contact form, with a clean professional design that highlights services and expertise.",
        "client": "Silicon Surge (Pvt) Ltd.",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/indonesia-flag-png-large.png",
        "country": "Indonesia",
        "date": "2024",
        "technologies": [
            "React.js",
            "Email.js"
        ],
        "url": "https://www.silicon-surge.com/",
        "images": [
            "https://ozcodelabsblob.blob.core.windows.net/projects/ss1.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/ss2.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/ss3.jpeg"
        ],
        "xs": 8
    },
    {
        "id": "13",
        "categories": ["web", "software", "shopify"],
        "type": "Fullstack Development",
        "title": "Exotic Technologies - Australia",
        "description": "A fully automated e-commerce platform for Exotic Technologies in Australia. Custom middleware using Node.js and AWS services automates inventory syncing, ordering, and fulfillment between the Shopify storefront and supplier systems.",
        "client": "Exotic Technologies",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/flag-jpg-xl-9-2048x1024.jpg",
        "country": "Australia",
        "date": "2024",
        "technologies": [
            "Node.js",
            "AWS",
            "Shopify"
        ],
        "url": null,
        "images": [
            "https://ozcodelabsblob.blob.core.windows.net/projects/exotictech1.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/exotictech2.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/exotictech3.jpeg"
        ],
        "xs": 8
    },
    {
        "id": "12",
        "categories": ["mobile"],
        "type": "Mobile App Development",
        "title": "No Scam Mobile App",
        "description": "A mobile application that helps users identify and report scams in their area, with real-time notifications and updates. Frontend developed with React Native and Firebase for authentication and data storage.",
        "client": "Solution365",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/flag-jpg-xl-9-2048x1024.jpg",
        "country": "Australia",
        "date": "2024",
        "technologies": [
            "React Native",
            "Firebase"
        ],
        "url": null,
        "images": [
            "https://ozcodelabsblob.blob.core.windows.net/projects/nosacam.jpeg"
        ],
        "xs": 4
    },
    {
        "id": "11",
        "categories": ["web", "lms"],
        "type": "Web Development",
        "title": "Digital Academy",
        "description": "An online learning platform for students and professionals to learn new skills. Users can find courses, enroll securely via a payment gateway, and receive real-time notifications with customized course recommendations.",
        "client": "Digital Academy",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/sri-lanka-flag-png-large.png",
        "country": "Sri Lanka",
        "date": "2024",
        "technologies": [
            "React.js",
            "Node.js",
            "SQL",
            "Azure Services"
        ],
        "url": "https://www.digitalacademy.lk/",
        "images": [
            "https://ozcodelabsblob.blob.core.windows.net/projects/da1.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/da2.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/da3.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/da4.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/da5.jpeg"
        ],
        "xs": 8
    },
    {
        "id": "10",
        "categories": ["web", "lms"],
        "type": "Web Development",
        "title": "STEMUP Spaces",
        "description": "A platform that connects students with STEM education programs and workshops. Organizations create and manage programs while students search, join, and participate with real-time notifications and secure user management.",
        "client": "STEMUP Education Foundation",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/sri-lanka-flag-png-large.png",
        "country": "Sri Lanka",
        "date": "2024",
        "technologies": [
            "React.js",
            "Node.js",
            "SQL",
            "Azure Services"
        ],
        "url": "https://spaces.stem.lk/",
        "images": [
            "https://ozcodelabsblob.blob.core.windows.net/projects/sp1.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sp2.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/sp3.jpeg"
        ],
        "xs": 4
    },
    {
        "id": "9",
        "categories": ["web", "lms"],
        "type": "Web Development",
        "title": "Micro:bit in Libraries",
        "description": "A platform with a series of workshops and events for students to learn coding with micro:bit. Admins create and manage programs while students find and join workshops with real-time notifications and secure user management.",
        "client": "STEMUP Education Foundation",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/sri-lanka-flag-png-large.png",
        "country": "Sri Lanka",
        "date": "2024",
        "technologies": [
            "React.js",
            "Node.js",
            "SQL",
            "Azure Services"
        ],
        "url": "https://microbitinlibraries.stem.lk/",
        "images": [
            "https://ozcodelabsblob.blob.core.windows.net/projects/mb1.jpeg"
        ],
        "xs": 4
    },
    {
        "id": "8",
        "categories": ["web", "software"],
        "type": "Web Development",
        "title": "Xternship Portal",
        "description": "Xternship Portal is a Web Application that connects students with companies for internships. It is a platform where students can apply for internships and companies can post their internships and hire students. After hiring, companies can track the progress of the students, evaluate them and provide feedback.",
        "client": "Xternship",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/sri-lanka-flag-png-large.png",
        "country": "Sri Lanka",
        "date": "2024",
        "technologies": [
            "ReactJS",
            "NodeJS",
            "Azure Functions",
            "Azure Cosmos DB for MongoDB",
            "Azure Blob Storage",
            "Email Communication Services Domain",
            "Azure Communication Service",
            "B2C Tenant",
            "App Service"
        ],
        "url": "https://xternship-frontend.vercel.app/",
        "images": [
            "https://i.ibb.co/MNbwthz/xtern1.png",
            "https://i.ibb.co/rdjSS4w/xtern2.png",
            "https://i.ibb.co/x2KyPBd/xtern3.png"
        ],
        "xs": 8
    },
    {
        "id": "7",
        "categories": ["web", "lms"],
        "type": "Web Development",
        "title": "Yasalanka Physics",
        "description": "A website for a physics teacher to provide online classes and resources for students. Students can access course materials, assignments, video lectures, and participate in online classes with secure login and real-time notifications.",
        "client": "Yasalanka Physics",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/sri-lanka-flag-png-large.png",
        "country": "Sri Lanka",
        "date": "2023",
        "technologies": [
            "React.js",
            "Firebase"
        ],
        "url": "https://www.yasalankaphysics.lk/",
        "images": [
            "https://ozcodelabsblob.blob.core.windows.net/projects/ys1.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/ys2.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/ys3.jpeg",
            "https://ozcodelabsblob.blob.core.windows.net/projects/ys4.jpeg"
        ],
        "xs": 4
    },
    {
        "id": "6",
        "categories": ["web"],
        "type": "Web Development",
        "title": "CoderDojo Sri Lanka",
        "description": "Voluntary contribution with Mr. Prabhath Mannapperuma to open source project of STEMUP Education Foundation through Github.",
        "client": "STEMUP Education Foundation",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/sri-lanka-flag-png-large.png",
        "country": "Sri Lanka",
        "date": "2023",
        "technologies": [
            "ReactJS",
            "SCSS",
            "Azure DevOps",
            "Azure App Service"
        ],
        "url": "https://coderdojo.lk/",
        "images": [
            "https://i.ibb.co/VgGf2R9/coderdojo1.png",
            "https://i.ibb.co/ZY1LrSY/coderdojo2.png",
            "https://i.ibb.co/ZdZvLDk/coderdojo3.png"
        ],
        "xs": 4
    },
    {
        "id": "5",
        "categories": ["web"],
        "type": "Web Development",
        "title": "NEIC",
        "description": "The official website of Central Environmental Authority of Sri Lanka Government. The project by Airstudios. Role: Front End Developer",
        "client": "Central Environmental Authority - Sri Lanka.",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/sri-lanka-flag-png-large.png",
        "country": "Sri Lanka",
        "date": "2022",
        "technologies": [
            "HTML5",
            "CSS3"
        ],
        "url": "http://www.neic.cea.lk/",
        "images": [
            "https://i.ibb.co/vYK37mS/neic1.png",
            "https://i.ibb.co/XbgsgC4/neic2.png",
            "https://i.ibb.co/9HT8YgS/neic3.png"
        ],
        "xs": 4
    },
    {
        "id": "4",
        "categories": ["web", "software"],
        "type": "Web Development",
        "title": "Qonvo",
        "description": "A privacy protected Meeting Platform. This is my second year group project. Technologies - Deep Learning (classification) - Python Media Pipe",
        "client": "Open Source Project",
        "countryFlag": "https://www.countryflags.com/wp-content/uploads/sri-lanka-flag-png-large.png",
        "country": "Sri Lanka",
        "date": "2022",
        "technologies": [
            "HTML5",
            "CSS3",
            "Agora SDK",
            "Web RTC",
            "JavaScript"
        ],
        "url": "http://www.neic.cea.lk/",
        "images": [
            "https://i.ibb.co/vQrQwTg/qonvo1.png",
            "https://i.ibb.co/T1S545P/qonvo2.png",
            "https://i.ibb.co/DfrGFxV/qonvo3.png"
        ],
        "xs": 4
    },
    {
        "id": "3",
        "categories": ["web"],
        "type": "Web Development",
        "title": "Weathreo",
        "description": "A weather forecast application is designed to provide accurate and up-to-date weather information in various locations to users.",
        "client": "Open Source Project",
        "date": "2022",
        "technologies": [
            "ReactJS",
            "CSS3",
            "Open Weather API",
            "GEO API"
        ],
        "url": "https://isw200.github.io/weatherapp/",
        "images": [
            "https://i.ibb.co/h993VZb/weathreo1.png",
            "https://i.ibb.co/TP2969Q/weathreo2.png"
        ],
        "xs": 4
    },
    {
        "id": "2",
        "categories": ["web", "design"],
        "type": "Web Development",
        "title": "3D Box",
        "client": "Open Source Project",
        "description": "A sample landing page website webpage using 3D models for 3D animation company.",
        "date": "2022",
        "technologies": [
            "ReactJS",
            "CSS3",
            "Spline"
        ],
        "url": "https://isw200.github.io/threed/",
        "images": [
            "https://i.ibb.co/68yqCJN/threed1.png",
            "https://i.ibb.co/s1zBXHR/threed2.png",
            "https://i.ibb.co/qs2z3nk/threed3.png"
        ],
        "xs": 4
    },
    {
        "id": "1",
        "categories": ["software"],
        "type": "Computer Application",
        "title": "Consultation Management",
        "description": "A full stack application consultations management system using OOP concepts for a skin consultation centre.",
        "client": "Open Source Project",
        "date": "2021",
        "technologies": [
            "Java",
            "CSS3",
            "Java-Swing"
        ],
        "url": null,
        "images": [
            "https://i.ibb.co/wK6Lvhh/skincare.png"
        ],
        "xs": 4
    }
]

export default PROJECTS;
